import React from 'react';
import { Section } from '../ui/Section';
import { X } from 'lucide-react';
export function WhatItsNot() {
  const notItems = ['No es una cura milagrosa', 'No es una rutina larga de 1 hora', "No es 'aguántate el dolor'", 'No es ejercicio agresivo', 'No requiere equipo caro'];
  return <Section background="dark" className="border-y border-[#2a3245]" data-id="element-178">
      <div className="max-w-3xl mx-auto text-center" data-id="element-179">
        <h2 className="text-2xl md:text-3xl font-bold text-[#f5f0e8] mb-8 font-serif" data-id="element-180">
          Qué <span className="text-[#e85d5d]" data-id="element-181">NO</span> es
        </h2>
        <p className="text-gray-400 mb-10" data-id="element-182">
          Para filtrar y aumentar tu confianza. Preferimos ser claros sobre lo
          que no ofrecemos.
        </p>

        <div className="grid sm:grid-cols-2 gap-4 text-left" data-id="element-183">
          {notItems.map((item, idx) => <div key={idx} className="flex items-center gap-3 p-3" data-id="element-184">
              <X className="text-[#e85d5d] w-5 h-5 flex-shrink-0" data-id="element-185" />
              <span className="text-gray-300" data-id="element-186">{item}</span>
            </div>)}
          <div className="flex items-center gap-3 p-3" data-id="element-187">
            <X className="text-[#e85d5d] w-5 h-5 flex-shrink-0" data-id="element-188" />
            <span className="text-gray-300" data-id="element-189">No es sustituto de tu médico</span>
          </div>
        </div>
      </div>
    </Section>;
}